import * as d3 from 'd3';
import React, { useRef, useEffect } from 'react';

function BarChart({ width, height, data }){
	const ref = useRef();

	useEffect(() => {
		const svg = d3.select(ref.current)
		.attr("width", width)
		.attr("height", height)
	}, []);

	useEffect(() => {
		draw();
	}, [data]);

	const draw = () => {

		var dataset = {
			"children": data
		};

		var color = ['#4d82f7', '#ed4f8c', '#122f6f', '#f7be45'].concat(d3.schemeCategory10);
		color = ['#4d82f7', '#ed4f8c', '#122f6f', '#f7be45'].concat(d3.schemeCategory10).concat(d3.schemeCategory10).concat(d3.schemeCategory10).concat(d3.schemeCategory10).concat(d3.schemeCategory10);
		var width = 840, height = 820;

		var bubble = d3.pack(dataset)
		.size([width, height])
		.padding(10);

		const svg = d3.select(ref.current).append("svg")
		.attr('viewBox', "0, 0, " + width + ", " + height)
		.attr("class", "bubble");

		var nodes = d3.hierarchy(dataset)
		.sum(function (d) {
			return d.count;
		});

		function valid_color(c) {
			var re = new RegExp("[0-9A-F]{6}","i");
			return c.match(re);
		}

		function set_uppercase(field) {
			return field = field.toUpperCase();
		}

		function enter_color(source) {
			source = set_uppercase(source); source = opposite(source);
			return source;
		}

		function opposite(c) {
			var result=''; var ch=''; var list1='0123456789ABCDEF'; var list2='FEDCBA9876543210';
			for(var i=0;i<c.length;i++) { ch=c.charAt(i); for(var n=0;n<list1.length;n++){ if(ch==list1.charAt(n)) result += list2.charAt(n); } }
			return result;
		}

		function complementaryColor(bubble_color){
			bubble_color = bubble_color.replace("#", "");
			if(!valid_color(bubble_color) || bubble_color.length<6) bubble_color='000000';
			return '#'+enter_color(bubble_color);
		}

		var node = svg.selectAll(".node")
		.data(bubble(nodes).descendants())
		.enter()
		.filter(function (d) {
			return !d.children
		})
		.append("g")
		.attr("class", "node")
		.attr("transform", function (d) {
			return "translate(" + d.x + "," + d.y + ")";
		});

		var tooltip = d3.select(".b1")
		.style("position", "absolute")
		.style("z-index", "10")
		.style("visibility", "hidden")
		.style("color", "red");

		node.append("circle")
		.attr("r", function (d) {
			return d.r;
		})
		.style("fill", function (d, i) {
			return color[i];
		})
		.on("mouseover", function(d, i) {
			tooltip.style("color", complementaryColor(color[i.data.key]));
			tooltip.text(i.data.name);return tooltip.style("visibility", "visible");})
		.on("mousemove", function(d, i){
			return tooltip.style("top", (d.pageY-10)+"px").style("left",(d.pageX+10)+"px");})
		.on("mouseout", function(){return tooltip.style("visibility", "hidden");});


		function clipText (d, t, scale) {
			var name = t.substring(0, d.r/scale);
			if (name.length < t.length) {
				name = name.substring (0, name.length - Math.min(2, name.length)) + "...";
			}
			return name;
		}

		node.append("a")
		.attr("href", function (d) {
			return '/' + 'dept_name='+d.data.name;
			// return journal_vars.home_url + '/' + journal_vars.page.resource + '/?source__in='+journal_vars.record_id+'&dept_name='+d.data.name;
		})
		.attr("target", function (d) {
			return "_blank";
		})
		.append("text")
		.text(function(d) {
			return clipText(d, d.data.name, 5)
		})
		.attr("font-size", "12px")
		.style("text-anchor", "middle")
		.attr("fill", "white")

		d3.select(self.frameElement)
		.style("height", height + "px");
	}

	return (
		<div className="chart">
			<svg ref={ref}></svg>
			<div className="b1"></div>
		</div>

	)

}

export default BarChart;